export const asyncStatus = {
    IDLE: "idle",
    LOADING: "loading",
    SUCCEEDED: "succeeded",
    ERROR: "error",
  };
  
  
  export const type_constant = {
    LOGIN: "LOGIN",
    CHECK_AUTH: "CHECK_AUTH",
    FORGOT_PASSWORD: "FORGOT_PASSWORD",
    CREATE_AD: "CREATE_AD",
    UPDATE_AD: "UPDATE_AD",
    SUBMIT_PAYMENT: "SUBMIT_PAYMENT",
    CANCEL_SUBSCRIPTION: "CANCEL_SUBSCRIPTION",
    GET_AD: "GET_AD",
    GET_AD_BY_ID: "GET_AD_BY_ID",
    GET_ANALYTICS: "GET_ANALYTICS",
    GET_CATEGORY: "GET_CATEGORY",
    DELETE_AD_BY_ID: "DELETE_AD_BY_ID",
    OTP_VERIFY: "OTP_VERIFY",
    CREATE_PASSWORD: "CREATE_PASSWORD",
    UPDATE_PROFILE: "UPDATE_PROFILE",
    SIGNUP: "SIGNUP",
    SIGNUP_VENDOR: "SIGNUP_VENDOR",
    SIGNUP_SERVICES_GET: "SIGNUP_SERVICES_GET",
    ADD_SERVICE: "ADD_SERVICE",
    GET_USERS: "GET_USERS",
    GET_VENDOR: "GET_VENDOR",
    GET_CATEGORY: "GET_CATEGORY",
    ADD_CATEGORY: "ADD_CATEGORY",
    UPDATE_CATEGORY: "UPDATE_CATEGORY",
    DELETE_CATEGORY: "DELETE_CATEGORY",
    GET_DASHBOARD: "GET_DASHBOARD",
    GET_ALL_ADS: "GET_ALL_ADS",
    BLOCK_AD: "BLOCK_AD",
    BLOCK_USER: "BLOCK_USER",
    UPDATE_USER: "UPDATE_USER",
    DELETE_USER: "DELETE_USER",
    ADD_USER: "ADD_USER",
  }
  
  
  export const save_tokens_constant = {
    AUTH:"auth"
  }

  export const session_expired = "@session_expired";
